// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"358":"07b70609","515":"c71ed402"}[chunkId] + ".chunk.js";
};